import { HubConnectionBuilder, LogLevel } from '@aspnet/signalr'
export default {
  install (Vue) {
    const connection = new HubConnectionBuilder()
      .withUrl('https://mfapi.smarttile.co.uk/myfithub?location=DemoLocation')
      // .withUrl('https://stcloud.cleverenrol.com:8073/demoa1hub?location=demolocation1')
      .configureLogging(LogLevel.Information)
      .build()

    // use new Vue instance as an event bus
    const demoHub = new Vue() 
    // every component will use this.$questionHub to access the event bus
    Vue.prototype.$demoHub = demoHub
    // Forward server side SignalR events through $questionHub, where components will listen to them
    connection.on('MFLive', (member, location, gate) => {
      demoHub.$emit('demo-changed', {member, location, gate})
    })
 
    let startedPromise = null
    function start () {
      startedPromise = connection.start().catch(err => {
        console.error('Failed to connect with hub', err)
        return new Promise((resolve, reject) => 
          setTimeout(() => start().then(resolve).catch(reject), 5000))
      })
      return startedPromise
    }
    connection.onclose(() => start())
    
    start()
  }
  
}